import {
  GET_CONDITIONMETADATA
} from '../actions/types';

const INITIAL_STATE = {
  conditions: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_CONDITIONMETADATA:
      return {
        ...state,
        conditions: action.data
      };
    default:
      return state;
  }
};